module.exports = __webpack_public_path__ + "static/media/map_xl.9bba2ee2.png";